import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import LImage from '@max/leez-image';
import ScrollView from '@hfe/max-scrollview';
import LinearGradient from '@hfe/max-linear-gradient';
import { TeamMemberRole } from '@/types/teamRanking';
import Button from '@hfe/max-button';
import './index.scss';
import { useMonitorEngineContext } from '@nibfe/mcp-monitor-sdk';
import { USER_DEFAULT_AVATAR } from '@/types/shared';
import Avatar from '@/components/avatar';
import { lessThan, MTNewDigitalDisplayStyle, convertCentsToYuanInteger } from '@/utils/common';
import PointerVapContainer from '@/components/pointer-vap-container';
import LText from '@max/leez-text';
import LModal from '@max/leez-modal';
import { useState, createElement } from '@max/max';
import ModalBottomBtn from '@/components/modal-bottom-button';
import { TeamInfoTheme } from '@/theme/main';
import { getSystemType, SystemType } from '@nibfe/mkt-env-api';
export default function TeamInfo(props) {
    var _a, _b;
    const { teamInfo, onInviteMember, onInviteCall, onOpenRewardRecord, onOpenRanking, onOpenWishPopup, callValueToPointsDesc, freeCardMaxAmount, callValueDesc } = props;
    const ctx = useMonitorEngineContext();
    const userId = Number(ctx._runtimeInfo.commonParams.userId);
    const [showRewardGapModal, setShowRewardGapModal] = useState(false);
    const [gapValue, setGapValue] = useState(0);
    const systemType = getSystemType();
    const isIOS = systemType === SystemType.ios;
    const isAndroid = systemType === SystemType.android;
    if (!teamInfo) {
        return null;
    }
    // 获取排名显示文案
    const getRankingText = (rank, hasReward) => {
        const { targetRankTeamValue } = props;
        if (targetRankTeamValue && lessThan(teamValue, targetRankTeamValue)) {
            return <Text className="team-info-rank">
        还差<Text style={{
                color: '#FF2D19',
                marginLeft: '4rpx',
                marginRight: '4rpx'
            }}>
          {targetRankTeamValue - teamValue}
        </Text>{`${callValueDesc || '心愿值'}即可全队获得最高${freeCardMaxAmount || 666}元免单卡奖励！`}
      </Text>;
        }
        if (rank !== undefined && rank > 0) {
            // 有排名的情况
            const rankingPart = <Text className="team-info-rank">
          本场排名 第<Text style={{
                color: '#FF2D19',
                marginLeft: '4rpx',
                marginRight: '4rpx'
            }}>{rank}</Text>名！
        </Text>;
            const encouragementPart = hasReward ? `当前小队已上榜！` : '排名靠前的队伍会获得更多奖励～';
            return <Text className="team-info-rank">
          {rankingPart}
          <Text className="team-info-rank">{encouragementPart}</Text>
        </Text>;
        }
        else {
            if (hasReward) {
                return <Text className="team-info-rank">继续加油～当前小队已上榜！</Text>;
            }
            const { rewardGap } = teamInfo;
            const hasValidRewardGap = rewardGap && !Number.isNaN(rewardGap) && Number(rewardGap) > 0;
            // 没有排名的情况
            return hasValidRewardGap ? <Button style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center'
            }} onPress={() => {
                setShowRewardGapModal(true);
                setGapValue(Number(rewardGap));
            }}>
          <Text className="team-info-rank">
            继续加油～还差{rewardGap}战队值即可上榜！
          </Text>
          <LImage source={{
                uri: TeamInfoTheme.QuestionIcon
            }} style={{
                width: '26rpx',
                height: '26rpx'
            }}/>
        </Button> : <Text className="team-info-rank">继续加油～排名靠前的队伍会获得更多奖励～</Text>;
        }
    };
    const getRankingStageText = () => {
        const { teamInfo } = props;
        if (!teamInfo || !teamInfo.rewardThresholdInfo) {
            return <Text className="team-info-rank__def">继续加油～排名靠前的队伍会获得更多奖励～</Text>;
        }
        const { rewardThresholdInfo = {} } = teamInfo;
        let rewardThresholdInfos = Object.values(rewardThresholdInfo);
        if (rewardThresholdInfos.length === 0) {
            return <Text className="team-info-rank__def">继续加油～排名靠前的队伍会获得更多奖励～</Text>;
        }
        // 先按照 rank 正序排列
        rewardThresholdInfos = rewardThresholdInfos.sort((a, b) => a.rank - b.rank);
        // 按 gapValue 排序，找出已达到区间（最小正值）和未达到区间（最小负值）
        // 当 gapValue === 0 时，需要通过 isCurrentTeam 字段判断用户是否真正达到了该排名阶段
        // 第一步：先找已达到的排名区间 curStageRewardThresholdInfo
        const curStageRewardThresholdInfo = rewardThresholdInfos.filter(info => {
            // gapValue > 0：已超过该排名区间
            if (info.gapValue > 0)
                return true;
            // gapValue === 0 且 isCurrentTeam === true：恰好达到该排名区间
            if (info.gapValue === 0)
                return info.isCurrentTeam === true;
            return false;
        }).sort((a, b) => a.gapValue - b.gapValue)[0]; // 最小正值（最接近0）
        // 第二步：再找未达到的排名区间 nextStageRewardThresholdInfo
        let nextStageRewardThresholdInfo;
        // 如果找到了 curStageRewardThresholdInfo，则根据其索引来确定 nextStageRewardThresholdInfo
        if (curStageRewardThresholdInfo) {
            const curIndex = rewardThresholdInfos.findIndex(info => info === curStageRewardThresholdInfo);
            if (curIndex > 0) {
                nextStageRewardThresholdInfo = rewardThresholdInfos[curIndex - 1];
            }
        }
        else {
            // 如果没有找到 curStageRewardThresholdInfo，则按原逻辑查找
            // 先找 gapValue === 0 且 isCurrentTeam === false 的数据，按 rank 倒序排
            nextStageRewardThresholdInfo = rewardThresholdInfos.filter(info => info.gapValue === 0 && !info.isCurrentTeam).sort((a, b) => b.rank - a.rank)[0];
            // 如果没有找到，则找 gapValue < 0 的数据，按 gapValue 倒序排
            if (!nextStageRewardThresholdInfo) {
                nextStageRewardThresholdInfo = rewardThresholdInfos.filter(info => info.gapValue < 0).sort((a, b) => b.gapValue - a.gapValue)[0];
            }
        }
        // 情况1: 既有当前区间，也有下一个区间（用户在中间排名区间）
        if (curStageRewardThresholdInfo && nextStageRewardThresholdInfo) {
            const gapValueAbs = Math.abs(nextStageRewardThresholdInfo.gapValue);
            return gapValueAbs > 0 ? <Text className="team-info-rank-ratio">
          您的队伍在前<Text style={{
                color: '#FF2D19',
                marginLeft: '4rpx',
                marginRight: '4rpx'
            }}>
            {curStageRewardThresholdInfo.rank}
          </Text>名，还差<Text style={{
                color: '#FF2D19',
                marginLeft: '4rpx',
                marginRight: '4rpx'
            }}>
            {gapValueAbs}
          </Text>心愿值全队每人获得<Text style={{
                color: '#FF2D19',
                marginLeft: '4rpx',
                marginRight: '4rpx'
            }}>
            {convertCentsToYuanInteger(nextStageRewardThresholdInfo.rewardAdrUpper)}
          </Text>元免单卡
        </Text> : <Text className="team-info-rank__def">
          继续加油，再拉一人，即可全队每人获得<Text style={{
                color: '#FF2D19',
                marginLeft: '4rpx',
                marginRight: '4rpx'
            }}>
            {convertCentsToYuanInteger(nextStageRewardThresholdInfo.rewardAdrUpper)}
          </Text>元免单卡
        </Text>;
        }
        // 情况2: 只有当前区间，说明用户已经达到最高排名区间
        if (curStageRewardThresholdInfo && !nextStageRewardThresholdInfo) {
            return <Text className="team-info-rank-ratio">
          恭喜，您的队伍已经高居榜头，继续保持，全队每人可获得<Text style={{
                color: '#FF2D19',
                marginLeft: '4rpx',
                marginRight: '4rpx'
            }}>
            {convertCentsToYuanInteger(curStageRewardThresholdInfo.rewardAdrUpper)}
          </Text>元免单卡
        </Text>;
        }
        // 情况3: 只有下一个区间，说明用户还没达到最低排名区间
        if (!curStageRewardThresholdInfo && nextStageRewardThresholdInfo) {
            const gapValueAbs = Math.abs(nextStageRewardThresholdInfo.gapValue);
            return gapValueAbs > 0 ? <Button style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                marginTop: '-10rpx'
            }} onPress={() => {
                setShowRewardGapModal(true);
                setGapValue(gapValueAbs);
            }}>
          <View className="team-info-rank-wrap">
            <Text className="team-info-rank">您的队伍还未上榜，还差<Text style={{
                color: '#FF2D19',
                marginLeft: '4rpx',
                marginRight: '4rpx'
            }}>
              {gapValueAbs}
            </Text>心愿值全队每人获得
            </Text>
          </View>
          <View className="team-info-rank-wrap">
            <Text className="team-info-rank">
              <Text style={{
                color: '#FF2D19',
                marginLeft: '4rpx',
                marginRight: '4rpx'
            }}>
                {convertCentsToYuanInteger(nextStageRewardThresholdInfo.rewardAdrUpper)}
              </Text>元免单卡
            </Text>
            <LImage source={{
                uri: TeamInfoTheme.QuestionIcon
            }} borderRadius={0} style={{
                width: '26rpx',
                height: '26rpx'
            }}/>
          </View>
          
        </Button> : <Text className="team-info-rank__def">
          继续加油，再拉一人，即可全队每人获得<Text style={{
                color: '#FF2D19',
                marginLeft: '4rpx',
                marginRight: '4rpx'
            }}>
            {convertCentsToYuanInteger(nextStageRewardThresholdInfo.rewardAdrUpper)}
          </Text>元免单卡
        </Text>;
        }
        return <Text className="team-info-rank__def">继续加油～排名靠前的队伍会获得更多奖励～</Text>;
    };
    const { teamName, teamValue, memberCount, maxMemberCount, teamRank } = teamInfo;
    const emptySlots = maxMemberCount - memberCount;
    // const isMyTeam = teamInfo.role === TeamMemberRole.LEADER && teamInfo.teamLeaderId === userId;
    const isMyTeam = teamInfo.teamLeaderId === userId;
    const leaderAvatar = teamInfo.teamImg || ((_a = teamInfo.members.find(member => member.role === TeamMemberRole.LEADER)) === null || _a === void 0 ? void 0 : _a.avatar) || USER_DEFAULT_AVATAR;
    const myAvatar = ((_b = teamInfo.members.find(member => member.userId === userId)) === null || _b === void 0 ? void 0 : _b.avatar) || USER_DEFAULT_AVATAR;
    const restMembers = teamInfo.members.filter(member => member.role !== TeamMemberRole.LEADER && member.userId !== userId);
    return <>
      <View className="team-info-container">
        <LImage source={{
        uri: TeamInfoTheme.BackgroundImageCard
    }} style={{
        width: '702rpx',
        height: '666rpx'
    }} resizeMode="stretch" className="team-info-bg" showAnimatioin={false}>
          
          <View className="team-info-header">
            <Text className="team-info-title" numberOfLines={1}>{teamName}</Text>
          </View>

          
          <View className="team-info-call-section">
            <View className="team-info-call-value-container">
              <View className="team-info-call-icon">
                <LImage source={{
        uri: TeamInfoTheme.CallIcon
    }} style={{
        width: '22rpx',
        height: '20rpx'
    }}/>
                <Text className="team-info-call-label">{callValueDesc || '心愿值'}</Text>
              </View>
              <Text className="team-info-call-value" style={Object.assign(Object.assign({}, MTNewDigitalDisplayStyle), { top: isIOS ? '4rpx' : '0rpx' })}>
                {teamValue || 0}
              </Text>
            </View>

            
            <View style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center'
    }}>
              
              {getRankingStageText()}
            </View>
          </View>

          
          <View className="team-info-member-section" style={{
        height: '221rpx'
        // marginTop: teamInfo?.rewardThresholdInfo ? '10rpx' : '37rpx'
    }}>
            <View className="team-info-menber-wish">
              {teamInfo.wishCode ? <>
                    <Text className="team-info-member-wish-text" style={{
        color: "#555555"
    }}>
                      {"犒赏心愿 ｜ "}
                    </Text>
                    <Text className="team-info-member-wish-text" style={{
        fontWeight: "500"
    }}>
                      {teamInfo.wishContent}
                    </Text>
                  </> : <>
                  <Text x-if={isMyTeam} className="team-info-member-wish-text">
                    许愿得专属酒店折扣 +2026 心愿值
                  </Text>
                  <View x-if={isMyTeam} onClick={onOpenWishPopup}>
                    <LinearGradient start={{
        x: 0,
        y: 0
    }} end={{
        x: 1,
        y: 0
    }} colors={['#FFE74D', '#FFDD00']} className='team-info-member-wish-button'>
                      <Text className="team-info-member-wish-button-text">去许愿</Text>
                    </LinearGradient>
                  </View>
                </>}
              
            </View>
            

            
            <View style={{
        height: '96rpx',
        // marginTop: isMyTeam ? '0rpx' : '28rpx',
        marginTop: '0rpx'
    }}>
              <ScrollView horizontal style={{
        width: '544rpx'
    }} showsHorizontalScrollIndicator={false}>
                
                <Avatar avatar={leaderAvatar} badge="队长"/>

                
                <Avatar x-if={!isMyTeam} avatar={myAvatar} badge="我"/>

                {restMembers.map(member => <Avatar x-if={member.role === TeamMemberRole.MEMBER} avatar={member.avatar} key={member.userId}/>)}

                
                {Array.from({
        length: emptySlots
    }).map((_, index) => <Button key={index} className="team-info-empty-slot" onPress={onInviteMember}>
                    <View className="team-info-plus-icon">
                      <View className="team-info-plus-horizontal"/>
                      <View className="team-info-plus-vertical"/>
                    </View>
                  </Button>)}
              </ScrollView>
            </View>
          </View>

          
          <View className="team-info-buttons">
            
            <LImage source={{
        uri: TeamInfoTheme.RewardButtonImage
    }} style={{
        width: '110rpx',
        height: '110rpx'
    }} onPress={onOpenRewardRecord} borderRadius={0}/>

            <PointerVapContainer onPress={onInviteCall}>
              
              <LImage source={{
        uri: TeamInfoTheme.InviteCallButtonImage
    }} style={{
        width: '382rpx',
        height: '110rpx',
        overflow: 'visible'
    }}>
                <View x-if={props.inviteCallBadgeText} className="team-info-points-label">
                  <Text className="team-info-points-label-text">{props.inviteCallBadgeText}</Text>
                </View>
              </LImage>
            </PointerVapContainer>

            
            <LImage onPress={onOpenRanking} source={{
        uri: TeamInfoTheme.RankingListButtonImage
    }} style={{
        width: '110rpx',
        height: '110rpx'
    }} borderRadius={0}/>
          </View>
        </LImage>
      </View>
      <LModal visible={showRewardGapModal} onClosed={() => setShowRewardGapModal(false)} title={`还差${gapValue}战队值上榜`} onClosePress={() => setShowRewardGapModal(false)}>
        <>
          <LText style={{
        textAlign: 'center'
    }} type="body2">
            榜单每隔1小时加载，若您已邀请好友新增心愿值，请静候队伍上榜～
          </LText>
          <View style={{
        marginTop: '36rpx'
    }}>
            <ModalBottomBtn buttonText='我知道了' onPress={() => setShowRewardGapModal(false)}/>
          </View>
        </>
      </LModal>
    </>;
}
